import { useEffect } from 'react';
import { Card, Alert } from '@dreamtree-org/twreact-ui';
import { useAgentChat } from '@/lib/useAgentChat';
import ChatPanel from '@/components/ChatPanel';
import PageShell from '@/components/layout/PageShell';
import PageHeader from '@/components/layout/PageHeader';

/**
 * Internal chat page (PRD §3.8) — the full-page mounting mode for the same chat
 * (useAgentChat()/ChatPanel, shared with the floating AgentChatDock). The public embed
 * widget (client/src/pages/EmbedChat.jsx) is a separate, deliberately minimal surface —
 * see its own comment for why it doesn't share this component.
 */
export default function Chat() {
  const chat = useAgentChat();

  useEffect(() => {
    chat.loadAgents();
  }, []);

  return (
    <PageShell className="space-y-3">
      <PageHeader
        title="Chat"
        subtitle={<>Talk to an agent persona in real time.</>}
      />

      {chat.loadError && <Alert variant="error" title="Couldn't load agents">{chat.loadError}</Alert>}

      {chat.agentKey && (
        <Card className="flex flex-col h-[70vh] p-0 overflow-hidden">
          <ChatPanel
            agents={chat.agents}
            agentKey={chat.agentKey}
            onChangeAgent={chat.setAgentKey}
            sessionId={chat.sessionId}
            messages={chat.messages}
            sending={chat.sending}
            pendingJob={chat.pendingJob}
            onSend={chat.send}
            onAnswerQuestion={chat.answerQuestion}
            onUploadAttachment={chat.uploadAttachment}
            onClearChat={chat.clearChat}
            approvalMode={chat.approvalMode}
            onToggleApprovalMode={chat.setApprovalMode}
          />
        </Card>
      )}
    </PageShell>
  );
}
